/**
 * Layer Integration - Connects LayerManager with existing Design Studio
 * Phase 1: Integration with current text/image system
 */

(function() {
    'use strict';

    // Wait for DOM and LayerManager to be ready
    document.addEventListener('DOMContentLoaded', function() {
        // Get section ID
        const studioElement = document.querySelector('[data-section-id]');
        if (!studioElement) return;
        
        const sectionId = studioElement.getAttribute('data-section-id');
        const containerId = `designOverlay-${sectionId}`;
        
        // Wait for container to exist
        const container = document.getElementById(containerId);
        if (!container) {
            console.warn('Container not found, retrying...');
            setTimeout(arguments.callee, 100);
            return;
        }
        
        // Initialize LayerManager
        const layerManager = new LayerManager(sectionId, containerId);
        window.layerManager = layerManager; // Make globally accessible
        
        // Wait a bit for existing scripts to initialize
        setTimeout(() => {
            integrateWithExistingStudio(sectionId, layerManager);
        }, 500);
    });

    function integrateWithExistingStudio(sectionId, layerManager) {
        // Get existing elements
        const designText = document.getElementById(`designText-${sectionId}`);
        const textInput = document.getElementById(`textInput-${sectionId}`);
        const imageUpload = document.getElementById(`imageUpload-${sectionId}`);
        
        // Get buttons
        const addTextLayerBtn = document.getElementById(`addTextLayerBtn-${sectionId}`);
        const addImageLayerBtn = document.getElementById(`addImageLayerBtn-${sectionId}`);
        const bringForwardBtn = document.getElementById(`bringForwardBtn-${sectionId}`);
        const sendBackwardBtn = document.getElementById(`sendBackwardBtn-${sectionId}`);
        const bringToFrontBtn = document.getElementById(`bringToFrontBtn-${sectionId}`);
        const sendToBackBtn = document.getElementById(`sendToBackBtn-${sectionId}`);
        const alignCenterHBtn = document.getElementById(`alignCenterHBtn-${sectionId}`);
        const alignCenterVBtn = document.getElementById(`alignCenterVBtn-${sectionId}`);
        
        // Migrate existing text to first layer if it exists
        if (designText && designText.textContent && designText.textContent !== 'YOUR DESIGN HERE') {
            const existingText = designText.textContent;
            const computedStyle = window.getComputedStyle(designText);
            
            // Get position from existing element
            const overlay = designText.closest(`.cts-design-overlay-${sectionId}`);
            let x = 50, y = 50;
            if (overlay) {
                const overlayStyle = window.getComputedStyle(overlay);
                x = parseFloat(overlayStyle.left) || 50;
                y = parseFloat(overlayStyle.top) || 50;
            }
            
            // Update first layer with existing text properties
            if (layerManager.layers.length > 0 && layerManager.layers[0].type === 'text') {
                const firstLayer = layerManager.layers[0];
                layerManager.updateLayerProperty(firstLayer.id, 'content', existingText);
                layerManager.updateLayerProperty(firstLayer.id, 'fontFamily', computedStyle.fontFamily);
                layerManager.updateLayerProperty(firstLayer.id, 'fontSize', parseInt(computedStyle.fontSize) || 32);
                layerManager.updateLayerProperty(firstLayer.id, 'color', computedStyle.color);
                layerManager.updateLayerProperty(firstLayer.id, 'x', x);
                layerManager.updateLayerProperty(firstLayer.id, 'y', y);
                layerManager.selectLayer(firstLayer.id);
            }
        }
        
        // Add Text Layer Button
        if (addTextLayerBtn) {
            addTextLayerBtn.addEventListener('click', () => {
                const layerId = layerManager.createTextLayer('New Text', {
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: 32,
                    color: '#000000',
                    x: 50,
                    y: 50
                });
                layerManager.selectLayer(layerId);
            });
        }
        
        // Add Image Layer Button
        if (addImageLayerBtn) {
            addImageLayerBtn.addEventListener('click', () => {
                // Trigger file input
                if (imageUpload) {
                    imageUpload.click();
                }
            });
        }
        
        // Handle image upload
        if (imageUpload) {
            imageUpload.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (!file) return;
                
                const reader = new FileReader();
                reader.onload = (event) => {
                    const layerId = layerManager.createImageLayer(event.target.result, {
                        width: 200,
                        height: 200,
                        x: 50,
                        y: 50
                    });
                    layerManager.selectLayer(layerId);
                };
                reader.readAsDataURL(file);
            });
        }
        
        // Sync text input with selected text layer
        if (textInput) {
            textInput.addEventListener('input', (e) => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer && selectedLayer.type === 'text') {
                    layerManager.updateLayerProperty(selectedLayer.id, 'content', e.target.value);
                }
            });
        }
        
        // Arrange Controls
        if (bringForwardBtn) {
            bringForwardBtn.addEventListener('click', () => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer) {
                    layerManager.bringForward(selectedLayer.id);
                    updateArrangeButtons(sectionId, layerManager);
                }
            });
        }
        
        if (sendBackwardBtn) {
            sendBackwardBtn.addEventListener('click', () => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer) {
                    layerManager.sendBackward(selectedLayer.id);
                    updateArrangeButtons(sectionId, layerManager);
                }
            });
        }
        
        if (bringToFrontBtn) {
            bringToFrontBtn.addEventListener('click', () => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer) {
                    layerManager.bringToFront(selectedLayer.id);
                    updateArrangeButtons(sectionId, layerManager);
                }
            });
        }
        
        if (sendToBackBtn) {
            sendToBackBtn.addEventListener('click', () => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer) {
                    layerManager.sendToBack(selectedLayer.id);
                    updateArrangeButtons(sectionId, layerManager);
                }
            });
        }
        
        // Alignment Controls
        if (alignCenterHBtn) {
            alignCenterHBtn.addEventListener('click', () => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer) {
                    layerManager.centerHorizontally(selectedLayer.id);
                }
            });
        }
        
        if (alignCenterVBtn) {
            alignCenterVBtn.addEventListener('click', () => {
                const selectedLayer = layerManager.getSelectedLayer();
                if (selectedLayer) {
                    layerManager.centerVertically(selectedLayer.id);
                }
            });
        }
        
        // Update arrange button states
        function updateArrangeButtons(sectionId, manager) {
            const selectedLayer = manager.getSelectedLayer();
            if (!selectedLayer) {
                [bringForwardBtn, sendBackwardBtn, bringToFrontBtn, sendToBackBtn].forEach(btn => {
                    if (btn) btn.disabled = true;
                });
                return;
            }
            
            const index = manager.layers.findIndex(l => l.id === selectedLayer.id);
            const isFirst = index === 0;
            const isLast = index === manager.layers.length - 1;
            
            if (sendBackwardBtn) sendBackwardBtn.disabled = isFirst;
            if (bringForwardBtn) bringForwardBtn.disabled = isLast;
            if (sendToBackBtn) sendToBackBtn.disabled = isFirst;
            if (bringToFrontBtn) bringToFrontBtn.disabled = isLast;
        }
        
        // Update buttons when selection changes
        const originalSelectLayer = layerManager.selectLayer.bind(layerManager);
        layerManager.selectLayer = function(layerId) {
            originalSelectLayer(layerId);
            updateArrangeButtons(sectionId, layerManager);
        };
        
        // Initial button state
        updateArrangeButtons(sectionId, layerManager);
        
        // Sync text input when layer is selected
        const originalUpdatePropertiesPanel = layerManager.updatePropertiesPanel.bind(layerManager);
        layerManager.updatePropertiesPanel = function() {
            originalUpdatePropertiesPanel();
            
            // Sync text input with selected text layer
            const selectedLayer = this.getSelectedLayer();
            if (textInput && selectedLayer && selectedLayer.type === 'text') {
                textInput.value = selectedLayer.content;
            }
        };
        
        console.log('✅ Layer Integration initialized');
    }
})();

